import { useStore } from 'vuex';

import authApi from '@/modules/auth/api/authApi';
import utils from '@/utils/utils';

import { useLoading } from 'vue-loading-overlay';

const useSucursales = () => {
    const store = useStore();
    const $loading = useLoading();

    const cabecera = () => ({
        headers: {
            'Content-type': 'application/json',
            'Authorization': 'Bearer ' + store.getters['auth/getToken'],
        }
    });

    const obtenerSucursales = async (texto: string) => {
        const respuesta = {
            ok: false,
            data: undefined as any,
        };

        const loader = $loading.show(utils.configuracionLoading);
        try {
            const { data } = await authApi.get(
                `/sucursales/obtener-sucursales/${ texto }`,
                cabecera()
            );
            loader.hide();

            if (data.ok) {
                respuesta.ok = true;
                respuesta.data = data.datos;
            } else {
                utils.mostrarMensaje({
                    descripcion: data.mensaje.descripcion,
                    tipoMensaje: data.mensaje.tipoMensaje
                });
            }
        } catch (error) {
            loader.hide();

            utils.mostrarMensajeErrorApi(error);
        }

        return respuesta;
    }

    const obtenerSucursal = async (id_sucursal: number) => {
        const respuesta = {
            ok: false,
            data: undefined as any,
        };

        const loader = $loading.show(utils.configuracionLoading);
        try {
            const { data } = await authApi.get(
                `/sucursales/obtener-sucursal/${ id_sucursal }`,
                cabecera()
            );
            loader.hide();

            if (data.ok) {
                respuesta.ok = true;
                respuesta.data = data.datos;
            } else {
                utils.mostrarMensaje({
                    descripcion: data.mensaje.descripcion,
                    tipoMensaje: data.mensaje.tipoMensaje
                });
            }
        } catch (error) {
            loader.hide();

            utils.mostrarMensajeErrorApi(error);
        }

        return respuesta;
    }

    const grabarSucursal = async (sucursal: any) => {
        const respuesta = {
            ok: false,
            data: 0,
        };

        const loader = $loading.show(utils.configuracionLoading);
        try {
            const { data } = await authApi.post(
                '/sucursales/grabar-sucursal',
                sucursal,
                cabecera()
            );
            loader.hide();

            if (data.ok) {
                respuesta.data = data.datos;
                respuesta.ok = true;
            }
            utils.mostrarMensaje({
                descripcion: data.mensaje.descripcion,
                tipoMensaje: data.mensaje.tipoMensaje
            });
        } catch (error) {
            loader.hide();
            utils.mostrarMensajeErrorApi(error);
        }

        return respuesta;
    }

    const cambiarEstadoSucursal = async (id_sucursal: number, estado: boolean) => {
        const respuesta = {
            ok: false,
        };

        const loader = $loading.show(utils.configuracionLoading);
        try {
            const { data } = await authApi.post(
                '/sucursales/cambiar-estado-sucursal',
                { id_sucursal, estado },
                cabecera()
            );
            loader.hide();

            if (data.ok) {
                respuesta.ok = true;
            }
            utils.mostrarMensaje({
                descripcion: data.mensaje.descripcion,
                tipoMensaje: data.mensaje.tipoMensaje
            });
        } catch (error) {
            loader.hide();
            utils.mostrarMensajeErrorApi(error);
        }

        return respuesta;
    }

    return {
        obtenerSucursales,
        obtenerSucursal,
        grabarSucursal,
        cambiarEstadoSucursal,
    }
};

export default useSucursales;
